import styled from 'styled-components';
import react, {useState, useEffect} from 'react';
import Banner from '../images/arts.svg';
import Banner_mobile from '../images/arts_mobile.svg';
import { mediaQueries } from '../shared/config';
import GalleryGrid from './GalleryGrid';
import CardsBundle from './CardsBundle';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 100px;
    justify-content: space-between;
    ${mediaQueries.tablet} {
        height: auto;
    }
    /* border: 1px solid black; */

`

const BannerContainer = styled.div`
    position: relative;
    color: black;
    /* background-image: url(${Banner}); */
    background-position: top;
    background-size: cover;
    width: 100%;
    height: auto;
    /* border: 1px solid blue; */
`
const Image = styled.img`
    position: relative;
    object-fit: fill;
    width: 100%;
`

const Header = styled.div`
    align-items: center;
    justify-content: center;
`

const TextContainer = styled.div`
    color: black;
    padding: 70px 10vw;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    /* padding-top: 20px; */
    /* border: 1px solid blue; */
`
const data = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.news.wwbusinesses.JJ.jpg",
        section: "NEWS",
        title: "Hispanic, Latino business owners find home in Westwood community",
        article_link: "https://dailybruin.com/2021/10/07/hispanic-latino-business-owners-find-home-in-westwood-community/",
        byline: "By Justin Jung",
        section_link: "https://dailybruin.com/category/news"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/web.new.fiestamexicana.ALK.jpg",
        section: "NEWS",
        title: "Grupo Folklórico to premiere upcoming Fiesta Mexicana virtually",
        article_link: "https://dailybruin.com/2021/10/07/grupo-folklrico-to-premiere-upcoming-fiesta-mexicana-virtually/",
        byline: "By Constanza Montemayor",
        section_link: " https://dailybruin.com/category/news"
    },
    {
        image_link: "https://assets3.dailybruin.com/images/flatpage.2021.hhm/hhm_news_revisioningarthistory-4f746bfe7e4e7fc0da9ff5ef512a153f.jpg",
        section: "NEWS",
        title: "'A Ver: Revisioning Art History' series earns nominations for Latino Book Awards",
        article_link: "https://dailybruin.com/2021/10/07/a-ver-revisioning-art-history-series-earns-nominations-for-latino-book-awards/",
        byline: "By Constanza Montemayor",
        section_link: "https://dailybruin.com/category/news"

    },
    {
        image_link: "https://assets3.dailybruin.com/images/flatpage.2021.hhm/web.news.festivalmexicano.LK-68ded649d9efd9cd25ecaed017c4e982.jpg",
        section: "NEWS",
        caption: "Grupo Folklórico will premiere its 2021 Fiesta Mexicana in a prerecorded format in October. Traditionally, the dancers cheer each other on before performing.",
        article_link: "https://dailybruin.com",
        byline: "Ashley Kenney/Photo editor"

    }
]

const data2 = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.a_e.arturoofarrill.jpeg",
        section: "ARTS",
        title: "Arturo O'Farrill creates inclusive community at UCLA through music",
        article_link: "https://dailybruin.com/2021/10/07/arturo-ofarrill-creates-inclusive-community-at-ucla-through-music/",
        byline: "By Breanna Diaz",
        section_link: "https://dailybruin.com/category/arts-entertainment"

    },
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/hhm.a_e.tamarindo.png",
        section: "ARTS",
        title: "'Tamarindo' podcast uplifts Latinx community with important discussions",
        article_link: "https://dailybruin.com/2021/10/07/tamarindo-podcast-uplifts-latinx-community-with-important-discussions/",
        byline: "By Laura Carter",
        section_link: "https://dailybruin.com/category/arts-entertainment"
    },
    {
        image_link: "https://assets3.dailybruin.com/images/flatpage.2021.hhm/hhm.a_e.hispanicfilmtvrecs-42a64874fcff158cfc8e66881f2a19bc.png",
        section: "ARTS",
        title: "Film, TV show recommendations for Hispanic Heritage Month",
        article_link: "https://dailybruin.com/2021/10/07/film-tv-show-recommendations-for-hispanic-heritage-month/",
        byline: "By Breanna Diaz",
        section_link: "https://dailybruin.com/category/arts-entertainment"

    },
    {
        image_link: "https://assets3.dailybruin.com/images/flatpage.2021.hhm/My-favorite-family-dish-c0a1b02987b449a2b138c0387c78109f.png",
        section: "VIDEO",
        title: "Hispanic Heritage Month: My Favorite Family Recipe",
        article_link: "https://dailybruin.com/2021/10/07/hispanic-heritage-month-my-favorite-family-recipe/",
        byline: "By Crystal Trinh",
        section_link: "https://dailybruin.com/category/video"

    }
]

const img = [
    {
        image_link: "https://s3.us-west-1.amazonaws.com/features.dailybruin.com/2021/hhm/dancer3.gif",
        image_creds: "Ashley Kenney/Photo editor and Shirley Yao/Digital managing editor"
    }
]

export default function Culture(props){
    const media = window.matchMedia('(max-width: 450px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    media.addEventListener('change', () => {
    if (media.matches !== isMobile) {
        setIsMobile(media.matches);
    }
    });
    return(
        <Container>
            <div name={props.name}>
            <BannerContainer>
                {!isMobile && <Image src={Banner} alt="Arts and culture"/>}
                {isMobile && <Image src={Banner_mobile} alt="Arts and culture"/>}

            </BannerContainer>
            </div>
            <TextContainer>Los Angeles is brimming with art and culture from its prominent Latino community, which is worthy of recognition beyond just this month. From campus to the Westwood community, explore celebrations of tradition and representation.</TextContainer>
            <CardsBundle isRight hasPhoto data={data} img={img}/>
            <GalleryGrid data={data2}/>
        </Container>
    )
}